import { Auth, Notification } from "../../api";

export default {
  created() {
    Auth.get()
      .then(data => (this.roles = data))
      .catch(error =>
        Notification.notifyFailure(error, "Error retrieving roles")
      );
  },
  data() {
    return {
      roles: []
    };
  },
  methods: {
    hasAllRoles(...requestedRoles) {
      return requestedRoles.every(role => this.roles.includes(role));
    },
    hasAnyRoles(...requestedRoles) {
      return requestedRoles.some(role => this.roles.includes(role));
    }
  }
};
